import styled from "styled-components";
import tw from "twin.macro";

interface Colors {
  $innerColor?: string;
  $outerColor?: string;
}

export const StyledScrollShadow = styled.div`
  ${tw`tw-relative`}
`;

export const StyledScrollShadowTop = styled.div<Colors>`
  ${tw`tw-absolute tw-top-0 tw-inset-x-0 tw-h-2`}

  background-image: linear-gradient(
    to top,
    ${(props) =>
    props.$innerColor ? props.$innerColor : "var(--page-paper-main-shadow)"},
    ${(props) =>
    props.$outerColor ? props.$outerColor : "var(--page-paper-main)"}
  );
`;

export const StyledScrollShadowBottom = styled.div<Colors>`
  ${tw`tw-absolute tw-bottom-0 tw-inset-x-0 tw-h-2`}

  background-image: linear-gradient(
    to top,
    ${(props) =>
    props.$outerColor ? props.$outerColor : "var(--page-paper-main)"},
    ${(props) =>
    props.$innerColor ? props.$innerColor : "var(--page-paper-main-shadow)"}
  );
`;

export const StyledScrollShadowLeft = styled.div<Colors>`
  ${tw`tw-absolute tw-left-0 tw-inset-y-0 tw-w-2`}

  background-image: linear-gradient(
    to left,
    ${(props) =>
    props.$innerColor ? props.$innerColor : "var(--page-paper-main-shadow)"},
    ${(props) =>
    props.$outerColor ? props.$outerColor : "var(--page-paper-main)"}
  );
`;

export const StyledScrollShadowRight = styled.div<Colors>`
  ${tw`tw-absolute tw-right-0 tw-inset-y-0 tw-w-2`}

  background-image: linear-gradient(
    to right,
    ${(props) =>
    props.$innerColor ? props.$innerColor : "var(--page-paper-main-shadow)"},
    ${(props) =>
    props.$outerColor ? props.$outerColor : "var(--page-paper-main)"}
  );
`;

StyledScrollShadow.displayName = "StyledScrollShadow";
StyledScrollShadowTop.displayName = "StyledScrollShadowTop";
StyledScrollShadowBottom.displayName = "StyledScrollShadowBottom";
StyledScrollShadowLeft.displayName = "StyledScrollShadowLeft";
StyledScrollShadowRight.displayName = "StyledScrollShadowRight";
